export default __webpack_public_path__ + "static/media/gevindstænger.e9140425.svg";